import { isSequencerExercise, isTrackSetExercise } from '@ezchops/model/lib/lesson';
import { range } from 'lodash';
export function getSequencerConfig(exercise, tempo, timing) {
    if (isTrackSetExercise(exercise)) {
        const trackSet = exercise.track;
        return getTrackSetSequencerConfig(trackSet, [{ stem: 'track', start: 0, passes: 1 }], tempo, timing);
    }
    else if (isSequencerExercise(exercise)) {
        const { stems, parts } = exercise.track;
        return getTrackStemsSequencerConfig(stems, parts, tempo, timing);
    }
    else {
        return undefined;
    }
}
export function getTrackSetSequencerConfig(trackSet, parts, tempo, timing) {
    const track = trackSet.tracks.find((track) => track.tempo == tempo);
    if (track != null) {
        const steps = parts.flatMap(({ start, stem, passes }) => {
            const duration = track.duration;
            const offset = timing.tickTimestamp(start) - (track.offset ?? 0);
            return range(0, passes).map(pass => ({
                sample: stem,
                when: offset + pass * duration
            }));
        });
        return {
            samples: { 'track': track.url },
            steps
        };
    }
}
export function getTrackStemsSequencerConfig(stems, parts, tempo, timing) {
    const mediaMap = Object.fromEntries(Object.entries(stems.stems).map(([name, samples]) => {
        const media = samples.find(s => s.tempo == tempo);
        if (media == null) {
            throw new Error(`No media for tempo ${tempo} in stem ${name}`);
        }
        return [name, media];
    }));
    const samples = Object.fromEntries(Object.entries(mediaMap).map(([name, media]) => [name, media.url]));
    const steps = parts.flatMap(({ start, stem, passes }) => {
        const duration = mediaMap[stem].duration;
        const offset = timing.tickTimestamp(start);
        return range(0, passes).map(pass => ({
            sample: stem,
            when: offset + pass * duration
        }));
    });
    return { samples, steps };
}
//# sourceMappingURL=SequencerConfig.js.map